import { ShiftDifferences } from 'shared/components/shift-differences'

/**
 * The central cashbox's first page, `/cashdesk`: the Shift differences (ADR-0035),
 * the same table support reads. Receiving Cash bags, the money of every place and
 * the bags' differences are their own pages (tickets 15 + 31 + 30).
 */
export function ShiftsTab() {
	return <ShiftDifferences />
}
